var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecommendationsWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3538",
    "data-name": "Groupe 3538",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.295,
    height: 18.083,
    viewBox: "0 0 14.295 18.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2011",
    "data-name": "Trac\\xE9 2011",
    d: "M-291.895,2717.028a1.511,1.511,0,0,0,1.511,1.511,1.511,1.511,0,0,0,1.511-1.511,6.772,6.772,0,0,0-5.175-6.666,6.682,6.682,0,0,0-5.646,1.308,6.629,6.629,0,0,0-2.487,5.185v9.919a1.511,1.511,0,0,0,1.511,1.511,1.511,1.511,0,0,0,1.511-1.511v-9.919a3.621,3.621,0,0,1,1.36-2.831,3.673,3.673,0,0,1,3.106-.709A3.735,3.735,0,0,1-291.895,2717.028Z",
    transform: "translate(302.181 -2710.202)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2012",
    "data-name": "Trac\\xE9 2012",
    d: "M-261.709,2767.831l-4.553-4.429a1.511,1.511,0,0,0-2.137.03,1.511,1.511,0,0,0,.029,2.136l4.553,4.429a1.506,1.506,0,0,0,1.053.428,1.506,1.506,0,0,0,1.083-.458A1.511,1.511,0,0,0-261.709,2767.831Z",
    transform: "translate(275.546 -2752.342)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationsWhiteIcon);
export default __webpack_public_path__ + "static/media/recommendationsWhiteIcon.bb9c4828288e62537b8b851411ef7092.svg";
export { ForwardRef as ReactComponent };